const imagesSrc = "./images/";

export const imgSrc = imagesSrc;
export const logo = imagesSrc + "logo.png";
export const icon = imagesSrc + "icon.png";
export const name = "Bunchiz";
export const phone = { name: "+44 148 442 7544", link: "#" };
export const website = { name: "www.bunchizuk.co", link: "#" };
export const instagram = { name: "bunchizuk", link: "#" };
export const location = { name: "31-33 Zetland Street Huddersfield HD1 2RA", link: "#" };
export const info = { name: "allergen info", link: "#" };
export const cardsImage = imagesSrc + "icons/cards.png";
export const applepayImage = imagesSrc + "icons/apple-pay.png";
export const googlepayImage = imagesSrc + "icons/google-pay.png";
export const cardChipImage = imagesSrc + "card-chip.png";
export const worldMapImage = imagesSrc + "world-map.png";
export const defaultTips = [
    { name: "none", value: "0" },
    { name: "£2", value: 2 },
    { name: "£5", value: 5 },
    { name: "£10", value: 10 },
];

export const cartItems = [
    { id: 0, name: "Bunchiz Burger", price: "£8.98", qty: 1, meal: "7UP" },
    { id: 1, name: "Mighty Burger", price: "£10.98", qty: 1, meal: "Pepsi" },
    { id: 2, name: "Strawberry 400ML", price: "£10.98", qty: 1, meal: false },
];

export const categories = [
    {
        id: "1",
        name: "Beef Burger",
        color: "red",
        products: [
            {
                id: 1,
                image: "https://images.squarespace-cdn.com/content/v1/54fb5e8de4b07795ac9ff693/1663077956971-DFHCAFWDFF197BLGJJZW/food-illustrator-breakfast-illustration.jpg",
                name: "asdasd",
                description: "cheese slice , angus beef patty.",
                price: "7.99",
            },
            {
                id: 2,
                image: "https://images.squarespace-cdn.com/content/v1/54fb5e8de4b07795ac9ff693/1663077956971-DFHCAFWDFF197BLGJJZW/food-illustrator-breakfast-illustration.jpg",
                name: "asdasd",
                description: "cheese slice , angus beef patty.",
                price: "7.99",
            },
            {
                id: 3,
                image: "https://images.squarespace-cdn.com/content/v1/54fb5e8de4b07795ac9ff693/1663077956971-DFHCAFWDFF197BLGJJZW/food-illustrator-breakfast-illustration.jpg",
                name: "asdasd",
                description:
                    "cheese slice , angus beef patty.cheese slice , angus beef patty.cheese slice , angus beef patty.",
                price: "7.99",
            },
            {
                id: 4,
                image: "https://images.squarespace-cdn.com/content/v1/54fb5e8de4b07795ac9ff693/1663077956971-DFHCAFWDFF197BLGJJZW/food-illustrator-breakfast-illustration.jpg",
                name: "asdasd",
                description: "cheese slice , angus beef patty.",
                price: "7.99",
            },
            {
                id: 5,
                image: "https://images.squarespace-cdn.com/content/v1/54fb5e8de4b07795ac9ff693/1663077956971-DFHCAFWDFF197BLGJJZW/food-illustrator-breakfast-illustration.jpg",
                name: "asdasd",
                description: "cheese slice , angus beef patty.",
                price: "7.99",
            },
            {
                id: 6,
                image: "https://images.squarespace-cdn.com/content/v1/54fb5e8de4b07795ac9ff693/1663077956971-DFHCAFWDFF197BLGJJZW/food-illustrator-breakfast-illustration.jpg",
                name: "asdasd",
                description: "cheese slice , angus beef patty.",
                price: "7.99",
            },
        ],
    },
    { id: "2", name: "Chicken Burger", color: "orange" },
    { id: "3", name: "Grilled Menu", color: "green" },
    { id: "4", name: "Wraps", color: "blue" },
    { id: "5", name: "Kids Meal", color: "blue" },
    { id: "6", name: "Bunchiz Light Menu", color: "blue" },
    { id: "7", name: "Sides", color: "blue" },
    { id: "8", name: "Ice Cream", color: "blue" },
    { id: "9", name: "Milkshakes", color: "blue" },
    { id: "10", name: "Drinks", color: "blue" },
];
